export default __webpack_public_path__ + "static/media/amertrad9.0568c8a2.png";